import styled from 'styled-components'

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
  font-family: 'Inter', sans-serif;
  overflow-y: auto;
  min-height: 85%;
  max-height: 85%;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`

export const LoadingMessage = styled.p`
  display: flex;
  justify-content: center;
  text-align: center;
  background-color: #f5f5f5;

  img {
    width: 50px;
    margin-top: 30vh;
  }
`
